module.exports = __webpack_public_path__ + "img/logo1.0db36a84.png";